import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Button from './Button';
import ButtonGroup from './ButtonGroup';
import Dropdown from './Dropdown';
var defaultProps = {
  toggleLabel: 'Toggle dropdown',
  type: 'button'
};
var SplitButton = React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    bsPrefix = _ref.bsPrefix,
    size = _ref.size,
    variant = _ref.variant,
    title = _ref.title,
    type = _ref.type,
    toggleLabel = _ref.toggleLabel,
    children = _ref.children,
    onClick = _ref.onClick,
    href = _ref.href,
    target = _ref.target,
    menuRole = _ref.menuRole,
    renderMenuOnMount = _ref.renderMenuOnMount,
    rootCloseEvent = _ref.rootCloseEvent,
    props = _objectWithoutPropertiesLoose(_ref, ["id", "bsPrefix", "size", "variant", "title", "type", "toggleLabel", "children", "onClick", "href", "target", "menuRole", "renderMenuOnMount", "rootCloseEvent"]);
  return /*#__PURE__*/React.createElement(Dropdown, _extends({
    ref: ref
  }, props, {
    as: ButtonGroup
  }), /*#__PURE__*/React.createElement(Button, {
    size: size,
    variant: variant,
    disabled: props.disabled,
    bsPrefix: bsPrefix,
    href: href,
    target: target,
    onClick: onClick,
    type: type
  }, title), /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    split: true,
    id: id ? id.toString() : undefined,
    size: size,
    variant: variant,
    disabled: props.disabled,
    childBsPrefix: bsPrefix
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, toggleLabel)), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    role: menuRole,
    renderOnMount: renderMenuOnMount,
    rootCloseEvent: rootCloseEvent
  }, children));
});
SplitButton.defaultProps = defaultProps;
SplitButton.displayName = 'SplitButton';
export default SplitButton;